$( document ).on("turbo:load", function() {
  var app = $('#app');

  $(document).on('click', '.open-modal-copy', function(){
    $('.modal-body #id').val($(this).data('id'));
  });

  if ($('#copy-content-modal').length > 0) {
    var variant = $('.variants');

    app.on('change', function() {
      $.ajax({
        type: 'GET',
        url: 'contents/variants',
        data: { 'app': this.value },
        success: function(data) {
          if (data.length > 1) {
            variant.html('' +
              '<div class="form-group">' +
                '<label for="variant">Select Variant</label>' +
                '<select name="variant" id="variant" class="form-control"></select>' +
              '</div>'
            );
            data.forEach(function (object) {
              $('#variant').append('<option value="' + object.id + '">' + object.name + '</option>')
            })
          } else if (data.length == 1) {
            variant.empty();
            variant.html('<input type="hidden" name="variant" id="variant" value="' + data[0].id + '">')
          }
        }
      })
    })
  }
});

